var _circle, _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1494 5.97111C10.1494 5.71386 10.0503 5.4665 9.8726 5.28045L8.2886 3.62185C8.09991 3.42427 7.83861 3.3125 7.56541 3.3125H5.16505C4.61277 3.3125 4.16505 3.76022 4.16505 4.3125V9.60936C4.16505 10.1616 4.61277 10.6094 5.16505 10.6094H9.14941C9.7017 10.6094 10.1494 10.1616 10.1494 9.60936V5.97111Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.86441,
    height: 1.9548,
    transform: "matrix(-1 0 0 1 9.92188 6.91602)",
    fill: "#0073BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.154 3H7.81206H8.01803L8.16357 3.14553L10.1758 5.15784L10.3213 5.30337V5.50925V9.65789C10.3213 10.3979 9.71929 11 8.97917 11H5.154C4.41411 11 3.81211 10.3979 3.81211 9.65789V4.34212C3.81211 3.602 4.41411 3 5.154 3ZM4.30894 9.65788C4.30894 10.1247 4.68728 10.503 5.154 10.503H8.97917C9.4461 10.503 9.82445 10.1247 9.82445 9.65788V5.50923H8.51639C8.12756 5.50923 7.81206 5.19395 7.81206 4.80501V3.49694H5.154C4.68728 3.49694 4.30894 3.87528 4.30894 4.34212V9.65788Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFiles);
export default __webpack_public_path__ + "static/media/icon-files.ebd73d024f2313c4c703fc4b87fe59f7.svg";
export { ForwardRef as ReactComponent };